import { createSelector } from 'reselect';
import { createUnit } from '../i18n/unitQtyWrapper';
import { BASE_LAYERS, IMPORTED_SHAPEFILE } from '../constants/mapLayerIds';
import { SEASON_AGNOSTIC } from '../constants/seasonIds';
import { LOCALE_GROUPS } from '../constants/units';

const zonesSelector = (state) =>
  state.layers.list[SEASON_AGNOSTIC][BASE_LAYERS.SOIL_SSURGO].zones;

export const activeImportedShapefileSelector = (state) =>
  state.layers.list[SEASON_AGNOSTIC][IMPORTED_SHAPEFILE].importedShapefiles[0];

export const importedShapefilePropertiesSelector = (state) =>
  state.layers.list[SEASON_AGNOSTIC][IMPORTED_SHAPEFILE].properties;

export const soilSsurgoZonesSelector = createSelector(
  zonesSelector,
  (zones) => (
      zones &&
      zones.map((zone) => ({
        ...zone,
        area: createUnit(zone.area, 'meter^2')
          .forLocaleGroup(LOCALE_GROUPS.AREA)
          .toString(),
      }))
    )
);
